
import { Vue, Component, Prop } from 'vue-property-decorator'
import BackRoundCtrl from '~/components/common/ctrls/BackRoundCtrl.vue'

@Component({
  name: 'ApplicationReviewModalHeader',
  components: {
    BackRoundCtrl
  }
})
export default class ApplicationReviewModalHeader extends Vue {
  @Prop({ default: 'Review the application before sending' }) title!: string
  @Prop({ default: '' }) scholarshipName!: string
}
